module.exports = __webpack_public_path__ + "static/media/yield-improvement-desktop.22e9b182.svg";